import XLRLogger from 'src/common/helpers/logger';
import { shiftStart } from './service/shift-start-service';

export const notifyShiftStart = async (triggeringEvent: string): Promise<void> => {
  shiftStart(triggeringEvent).catch(err => {
    if (err.code === 'AccountNotFound') {
      throw err;
    } else {
      XLRLogger.error({
        message: `ShiftStartCommand: Failed notifying cashier shift start, but continue execution. Ex :${err.Message}`,
        source: 'shift-start.ts',
      });
    }
  });
};
